// Programmatic SEO Blog Generation
const locations = [
  { name: "Playa del Carmen", desc: "The main urban hub of the Riviera Maya, with lots of hotels, nightlife, shopping on 5th Avenue." },
  { name: "Tulum", desc: "Trendy and more bohemian, known for its beachfront hotels, restaurants and the famous cliff-top Mayan ruins." },
  { name: "Puerto Morelos", desc: "Smaller, quieter port town between Cancun and Playa, with a laid-back vibe and good access to the reef." },
  { name: "Akumal", desc: "Compact beach community between Playa and Tulum, popular for its calm bays and sea turtles." },
  { name: "Puerto Aventuras", desc: "Gated marina community south of Playa, with resorts, residential areas, and easy access to snorkeling." },
  { name: "Cozumel", desc: "Island major dive destination with coral reefs and cruise-ship infrastructure." },
  { name: "Cancun", desc: "The gateway to the Riviera Maya with big-resort hotel zones and pristine beaches." },
  { name: "Bacalar", desc: "Famous for its Lagoon of Seven Colors, offering a tranquil and magical escape." },
  { name: "Coba", desc: "Home to ancient jungle pyramids and rich Mayan history deep in the Riviera Maya." }
];

const topics = [
  "Best Eyelash Extensions",
  "Luxury Lash Lift",
  "Affordable Lashes",
  "Mobile Lash Service",
  "Bridal Makeup and Lashes",
  "Russian Volume Experts",
  "Wet Look Lash Trend",
  "Natural Lash Care",
  "Lash Refills",
  "Eyebrow Lamination"
];

const generateBlogPosts = () => {
  const posts = [];
  let id = 1;

  locations.forEach(loc => {
    topics.forEach(topic => {
      posts.push({
        id: id++,
        title: `${topic} in ${loc.name} - The Ultimate Guide 2025`,
        slug: `${topic.toLowerCase().replace(/ /g, '-')}-in-${loc.name.toLowerCase().replace(/ /g, '-')}`,
        city: loc.name,
        category: "Lash Guide",
        // NO IMAGES - Using 'brand-logo' keyword to trigger the brand component
        image: 'brand-logo',
        excerpt: `Looking for premium ${topic.toLowerCase()} in ${loc.name}? ${loc.desc} We offer mobile service directly to your location.`,
        content: `
          <h2>${topic} in ${loc.name}</h2>
          <p>Are you looking for the <strong>${topic.toLowerCase()}</strong> in <strong>${loc.name}</strong>? You have come to the right place.</p>
          
          <p><strong>${loc.name}</strong> is ${loc.desc.toLowerCase()} It is the perfect place to look your best.</p>

          <p>EyelashesMexico.com brings the highest standard of lash artistry to ${loc.name}. Our certified technicians specialize in creating custom looks that withstand the Mexican heat and humidity.</p>
          
          <h3>How to Book in ${loc.name}</h3>
          <p>We make it easy to get professional service right where you are staying in ${loc.name}.</p>
          <ul>
            <li><strong>Step 1:</strong> Choose your service from our menu.</li>
            <li><strong>Step 2:</strong> Click the WhatsApp button below.</li>
            <li><strong>Step 3:</strong> Send us your hotel or villa location in ${loc.name}.</li>
          </ul>

          <div style="background-color: #f0fdf4; padding: 20px; border-radius: 10px; border: 1px solid #bbf7d0; margin-top: 20px;">
            <h4 style="color: #006847; margin-top: 0;">Ready to Book?</h4>
            <p>Our team is ready to visit you in ${loc.name}.</p>
            <p><strong>Book now via WhatsApp: +52 984 177 1113</strong></p>
          </div>
        `
      });
    });
  });

  return posts;
};

export const blogPosts = generateBlogPosts();
export const blogCategories = ["All Posts", "Lash Guide", "Beauty Tips", "Aftercare"];